import { useQuery } from "@tanstack/react-query";
import { ShoppingCart, ArrowUpRight } from "@phosphor-icons/react";
import { fetchAffiliate, trackAffiliateClick } from "@/lib/api";

// "Rent / Buy on Prime Video" affiliate CTA (Amazon Associates). Hidden for kids/live
// titles (backend returns enabled:false) so the Kids hub stays affiliate-free.
export const AmazonBuyButton = ({ videoId, title }) => {
  const { data } = useQuery({
    queryKey: ["affiliate", videoId],
    queryFn: () => fetchAffiliate(videoId),
    enabled: !!videoId,
    staleTime: 1000 * 60 * 30,
  });

  if (!data?.enabled || !data?.amazon_url) return null;

  return (
    <a
      href={data.amazon_url}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid="amazon-buy-btn"
      onClick={() => trackAffiliateClick({ provider: "amazon", video_id: videoId, title })}
      className="rv-cta-glow group mt-4 inline-flex items-center gap-2.5 rounded-full border border-amber/60 bg-gradient-to-r from-amber/15 to-amber/5 px-6 py-3 font-mono text-[11px] uppercase tracking-[0.15em] text-amber"
    >
      <ShoppingCart size={17} weight="fill" className="transition-transform duration-300 group-hover:-rotate-12" />
      Rent / Buy on Prime Video
      <ArrowUpRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
};
